__turbopack_context__.v({
  "link": "MobileNavigation-module__ww35_W__link",
  "linkActive": "MobileNavigation-module__ww35_W__linkActive",
  "mask": "MobileNavigation-module__ww35_W__mask",
  "nav": "MobileNavigation-module__ww35_W__nav",
});
